const config = window.__ENV__;

if (!config) {
  throw new Error('Runtime configuration (env.js) not loaded');
}

export default config;